import { Flex } from '@uhg-abyss/web/ui/Flex';
import { LoadingSpinner } from '@uhg-abyss/web/ui/LoadingSpinner';

export interface Props {
  isLoading: boolean;
}

export const LoadingSpinnerComp = ({ isLoading }: Props) => (
  <Flex alignContent="center" css={{ height: '80vh' }} justify="center">
    <LoadingSpinner
      ariaLoadingLabel="loading results"
      data-testid="loading-spinner"
      isLoading={isLoading}
      size="xl"
    />
  </Flex>
);
